import type { WhereDataset } from '@parcel/filters';
import { useMutation } from '@tanstack/react-query';
import { apiFetch } from './api.js';
import type { AskWhereResponse } from './table-filter.js';

export function useAskFilters() {
  return useMutation({
    mutationFn: (input: { workspaceId: string; entity: WhereDataset; query: string }) =>
      apiFetch<AskWhereResponse>('/filters/ask', {
        method: 'POST',
        body: JSON.stringify({
          workspace_id: input.workspaceId,
          entity: input.entity,
          query: input.query,
        }),
      }),
  });
}
